import { cn } from "@/lib/utils";
import {
  QUESTION_TYPE_CHECKBOX,
  QUESTION_TYPE_DATE_HOUR,
  QUESTION_TYPE_INFO,
  QUESTION_TYPE_INPUT,
  QUESTION_TYPE_FILE,
  QUESTION_TYPE_PICTURES,
  QUESTION_TYPE_RADIO,
  QUESTION_TYPE_SELECT,
  QUESTION_TYPE_TEXTAREA,
} from "@/schemas/question";
import {
  TextCursorInput,
  Info,
  Paperclip,
  CalendarClock,
  Image,
} from "lucide-react";
import {
  RiRadioButtonLine,
  RiCheckboxLine,
  RiDropdownList,
} from "react-icons/ri";

interface QuestionTypeIconProps {
  type: string;
  className?: string;
}

export default function QuestionTypeIcon({
  type,
  className,
}: QuestionTypeIconProps) {
  const defaultClassName = cn("w-5 h-5", className);
  switch (type) {
    case QUESTION_TYPE_INPUT:
      return <TextCursorInput className={defaultClassName} />;
    case QUESTION_TYPE_TEXTAREA:
      return <TextCursorInput className={defaultClassName} />;
    case QUESTION_TYPE_RADIO:
      return <RiRadioButtonLine className={defaultClassName} />;
    case QUESTION_TYPE_CHECKBOX:
      return <RiCheckboxLine className={defaultClassName} />;
    case QUESTION_TYPE_INFO:
      return <Info className={defaultClassName} />;
    case QUESTION_TYPE_FILE:
      return <Paperclip className={defaultClassName} />;
    case QUESTION_TYPE_SELECT:
      return <RiDropdownList className={defaultClassName} />;
    case QUESTION_TYPE_DATE_HOUR:
      return <CalendarClock className={defaultClassName} />;
    case QUESTION_TYPE_PICTURES:
      return <Image className={defaultClassName} />;
    default:
      return null;
  }
}
